
class ConfigVM {
    public get countryCode(): string {
        return process.env.REACT_APP_COUNTRY_CODE ?? '+962';
    }
}

const configVM = new ConfigVM;
export default configVM;
